// @flow
import React from "react";

type SocialButtonProps = {
  url: string,
  text: string
};

export const SocialButtons = ({ url, text }: SocialButtonProps) =>
  <div>
    <Facebook url={url} />
    <Twitter url={url} text={text} />
    <Linkedin url={url} text={text} />
    <style jsx>{`
      div {
        display: inline-flex;
        justify-content: space-between;
        height: 32px;
        vertical-align: middle;
        width: 120px;
        margin-left: 12px;
      }
    `}</style>
  </div>;

export const Facebook = ({ url }: { url: string }) =>
  <a
    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    title="Facebook"
  >
    <svg width="32px" height="32px" viewBox="0 0 32 32">
      <polygon fill="#3C5A99" points="32 32 0 32 0 0 32 0" />
      <path
        d="M19.7187556,28.496096 L19.7187556,17.5468764 L23.3906311,17.5468764 L23.9414044,13.2823111 L19.7187556,13.2823111 L19.7187556,10.5576178 C19.7187556,9.32227556 20.0585956,8.47950222 21.8300267,8.47950222 L24.0897244,8.47950222 L24.0897244,4.66407111 C23.6990933,4.61232 22.3592533,4.49607111 20.7967467,4.49607111 C17.5389387,4.49607111 15.3094382,6.48631111 15.3094382,10.1337422 L15.3094382,13.2802489 L11.6258133,13.2802489 L11.6258133,17.5468764 L15.3094382,17.5468764 L15.3094382,28.496096 L19.7187556,28.496096 L19.7187556,28.496096 Z"
        fill="#FFFFFF"
      />
      <style jsx>{`
      svg {
        display: block;
        height: 32px;
        width: 32px;
      }
    `}</style>
    </svg>
  </a>;

export const Twitter = ({ url, text }: { url: string, text: string }) =>
  <a
    href={`https://www.twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&url=${encodeURIComponent(url)}&via=${"UBS_CIO"}`}
    target="_blank"
    rel="noopener noreferrer"
    title="Twitter"
  >
    <svg width="32px" height="32px" viewBox="0 0 32 32">
      <polygon fill="#41ABE1" points="32 32 0 32 0 0 32 0" />
      <path
        d="M25.8436267,9.89550222 C25.1209778,10.21776 24.3397156,10.4335644 23.5194133,10.5302578 C24.3592533,10.0302578 24.9959644,9.23825778 25.3006578,8.29393778 C24.5134933,8.75594667 23.6502756,9.09187556 22.7322489,9.27443556 C21.9920711,8.49219556 20.9451911,8 19.78112,8 C17.5506578,8 15.742064,9.80762667 15.742064,12.0401244 C15.742064,12.3584711 15.780032,12.6661333 15.8495004,12.9560711 C12.494032,12.7939378 9.51753067,11.1885689 7.52821867,8.74033778 C7.18143644,9.33596444 6.98028089,10.0303822 6.98028089,10.7705244 C6.98028089,12.1719111 7.69609422,13.4101511 8.77821867,14.1299022 C8.11809422,14.1104 7.493936,13.92784 6.94621867,13.6260267 L6.94621867,13.6739022 C6.94621867,15.6318773 8.33978133,17.2617511 10.1854364,17.6329084 C9.84950044,17.7266578 9.49206222,17.7735324 9.12393778,17.7735324 C8.86425067,17.7735324 8.61218667,17.750096 8.36425067,17.7071893 C8.87987556,19.3047822 10.3700942,20.4766578 12.1357191,20.5099093 C10.7539058,21.5918773 9.01368711,22.2384409 7.11818667,22.2384409 C6.791968,22.2384409 6.47165511,22.2189084 6.15624889,22.1876587 C7.94237333,23.3321902 10.0663751,24.002096 12.3496249,24.002096 C19.7773511,24.002096 23.8417778,17.8439076 23.8417778,12.5099022 C23.8417778,12.3341511 23.8398756,12.1602844 23.8261511,11.9884089 C24.6171911,11.4180978 25.3008178,10.70816 25.8398756,9.8976 L25.8437156,9.8976 L25.8435911,9.89555556 L25.8436267,9.89550222 Z"
        fill="#FFFFFF"
      />
    </svg>
    <style jsx>{`
      svg {
        display: block;
        height: 32px;
        width: 32px;
      }
    `}</style>
  </a>;

export const Linkedin = ({ url, text }: { url: string, text: string }) =>
  <a
    href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url
    )}&summary=${encodeURIComponent(text)}`}
    target="_blank"
    rel="noopener noreferrer"
    title="Linkedin"
  >
    <svg width="32px" height="32px" viewBox="0 0 32 32">
      <polygon fill="#0475B7" points="32 32 0 32 0 0 32 0" />
      <path
        d="M6.09543822,25.9809404 L10.3329707,25.9809404 L10.3329707,12.4067911 L6.09543822,12.4067911 L6.09543822,25.9809404 L6.09543822,25.9809404 Z M8.23778311,5.86590222 C6.79100089,5.86590222 5.84375111,6.87950222 5.84375111,8.20988444 C5.84375111,9.51262222 6.76240711,10.5538489 8.18684444,10.5538489 L8.21287644,10.5538489 C9.69068978,10.5538489 10.6093458,9.51262222 10.6093458,8.20988444 C10.5822204,6.87950222 9.690752,5.86590222 8.23778311,5.86590222 L8.23778311,5.86590222 Z M21.2764978,12.0914133 C19.0151644,12.0914133 18.0184,13.4177778 17.4580018,14.3429689 L17.4580018,12.4068089 L13.2215644,12.4068089 C13.2786898,13.6804089 13.2215644,25.9809707 13.2215644,25.9809707 L17.4580018,25.9809707 L17.4580018,18.4000338 C17.4580018,17.9935644 17.4852836,17.5923467 17.6017831,17.3071893 C17.9067911,16.4890347 18.5985956,15.6535644 19.7689422,15.6535644 C21.3038222,15.6535644 21.9211911,16.8942204 21.9211911,18.7169404 L21.9211911,25.9811271 L26.1562489,25.9811271 L26.1562489,18.1995644 C26.1562489,14.0315378 24.0659733,12.0914133 21.2764978,12.0914133 L21.2764978,12.0914133 Z"
        fill="#FFFFFF"
      />
      <style jsx>{`
      svg {
        display: block;
        height: 32px;
        width: 32px;
      }
    `}</style>
    </svg>
  </a>;



// WEBPACK FOOTER //
// ./src/components/Quiz/SocialIcons.js